// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3wJnn","inner":"Form_inner__B8WhF","range":"Form_range__1ZCT-","name":"Form_name__1KhiK","actions":"Form_actions__3wbIt"};